export default __webpack_public_path__ + "static/media/email.610ddc9c.png";